//#region Imports

import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';
import { Category } from '../../models/interfaces/category.interface';
import { CourseAboutForm } from '../../models/interfaces/forms/course-form.interface';

//#endregion

@Component({
  selector: 'l-course-summary-step',
  standalone: true,
  templateUrl: './course-summary-step.component.html',
  host: {
    class: 'flex min-h-0 flex-1 flex-col overflow-y-auto',
  },
  imports: [IconComponent],
})
export class CourseSummaryStepComponent {

  //#region Public Properties

  @Input({ required: true })
  public aboutForm!: FormGroup<CourseAboutForm>;

  @Input({ required: true })
  public categories: Category[] = [];

  @Input()
  public moduleCount: number = 0;

  @Input()
  public coverImageSrc: string = '';

  //#endregion

  //#region Getters

  public get courseNameDisplay(): string {
    return this.aboutForm.controls.title.value.trim() || '—';
  }

  public get categoryDisplay(): string {
    const categoryId = this.aboutForm.controls.categoryId.value;
    return this.categories.find((item) => item.id === categoryId)?.name ?? '—';
  }

  public get tagsDisplay(): string {
    const tags = this.aboutForm.controls.tags.value;
    return tags.length > 0 ? tags.map((tag) => tag.name).join('; ') : '—';
  }

  public get durationDisplay(): string {
    const trimmed = this.aboutForm.controls.duration.value.trim();

    if (!trimmed) {
      return '—';
    }

    if (/hora/i.test(trimmed)) {
      return trimmed;
    }

    return `${trimmed} horas`;
  }

  public get shortDescriptionDisplay(): string {
    return this.aboutForm.controls.shortDescription.value.trim() || '—';
  }

  public get detailedDescriptionDisplay(): string {
    return this.aboutForm.controls.detailedDescription.value.trim() || '—';
  }

  //#endregion

}
